import { Component } from '@angular/core';

@Component({
  selector: 'lib-shared-data-access',
  imports: [],
  templateUrl: './shared-data-access.html',
  styleUrl: './shared-data-access.css',
})
export class SharedDataAccess {}
